import axios from 'axios';


export async function searchAddressInfo({postalCode}) {
    try {
        if (!postalCode || postalCode.length < 9) {
            throw { message: 'Insira corretamente os dados de CEP para prosseguir!' }

        } else {
            const response = await axios.get(`https://viacep.com.br/ws/${postalCode}/json`);

            if (response.status == 200 && !response.data.erro) {
                // ALTERA OS DADOS DO FORMULÁRIO
                return response.data

            } else {
                throw {message: 'Não foi possível encontrar os dados de localização do CEP digitado.\n\nAnalize o que foi digitado e tente novamente ou entre em contato com o suporte SofChef.' }
            }
        }

    } catch (error) {
        console.error('ERROR - FIND LOCATION DATA FUNCTION:', error);
        
        if (error.code === 'ERR_NETWORK') {
            throw {message: 'Não foi possível encontrar os dados de localização do CEP digitado.\n\nMotivo: Erro de conexão\n\nTente novamente mais tarde ou entre em contato com o suporte SofChef.'}

        } else {
            throw {message: 'Não foi possível encontrar os dados de localização do CEP digitado.\n\nAnalize o que foi digitado e tente novamente ou entre em contato com o suporte SofChef.'}
        }
    }
}